import { render, staticRenderFns } from "./BlockProductHero.vue?vue&type=template&id=48c4dec2&scoped=true&"
import script from "./BlockProductHero.vue?vue&type=script&lang=ts&"
export * from "./BlockProductHero.vue?vue&type=script&lang=ts&"
import style0 from "./BlockProductHero.vue?vue&type=style&index=0&id=48c4dec2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c4dec2",
  null
  
)

export default component.exports